<template>
  <div class="navbar pr-3 navbar--administration">
    <KboSidebarItem
      v-if="userHasManagementPermission"
      icon="fas fa-map-marked-alt"
      :buttonStyle="{ height: '52px' }"
      :closable="false"
      :labelStyle="{ color: 'white' }"
      label="Flota"
      route="/fleet"
    />
    <div class="phone">
      <PushToTalk v-if="userHasManagementPermission && !isAreaSanitariaDeVigo" />
      <BarPhone v-if="userHasManagementPermission && !isAreaSanitariaDeVigo" />
    </div>
    <BarInfo class="info" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BarPhone from "@/components/navbar/BarPhone.vue";
import BarInfo from "@/components/navbar/BarInfo.vue";
import PushToTalk from "@/modules/pushtotalk/components/PushToTalk.vue";
import KboSidebarItem from "./Sidebar/KboSidebarItem.vue";
import { isAreaSanitariaDeVigo } from "@/utils/user-types";

export default {
  name: "NavBar",

  components: {
    BarPhone,
    BarInfo,
    PushToTalk,
    KboSidebarItem,
  },

  computed: {
    ...mapGetters("app", ["defaultWorkgroup"]),
    ...mapGetters("operators", ["userHasManagementPermission"]),
    isAreaSanitariaDeVigo,
  },
};
</script>

<style lang="scss" scoped>
.navbar {
  display: flex;
  height: 50px;
  align-items: center;
  // overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .info {
    flex: 1;
  }

  .phone {
    flex: 0.4;
    justify-content: center;
    align-items: center;
    display: flex;
    gap: 20px;
  }
}
</style>
